<rappider-button [text]="getModalButtonConfig().text"
                 [icon]="getModalButtonConfig().icon"
                 size="small"
                 (confirm)="handleIconPickerModalVisibility(true)"></rappider-button>

<rappider-modal [(visible)]="iconPickerModalVisibility"
                [footer]="null"
                title="Select Icon"
                className="icon-picker-modal">
  <rappider-icon-picker-two *ngIf="iconPickerModalVisibility"
                            [ngModel]="value"
                            (setSelectIcon)="onSelectedIcon($event)"
                            (cancelSelectedIcon)="handleIconPickerModalVisibility(false)"></rappider-icon-picker-two>
</rappider-modal>